<div [formGroup]="form">
  <div class="permissions" *ngIf="isPro">
    <sync-section-header [header]="'Permissions'"
        [description]="'Set the permissions allowed for recipients of this link.'" [level]="'subtitle'">
    </sync-section-header>

    <sync-select class="select-permissions" [label]="'Permissions'"  [list]="permissionList"
        formControlName="permission" [errorMsg]="getErrorMessage('permission')">
    </sync-select>

    <div class="caption permission-text" *ngIf="!item.is_shared && isMSOfficeFile && fileType !== 'dir' && isEditPermission">The edit feature is only available to authenticated users for MS Office files.</div>
    <div class="caption permission-text" *ngIf="item.is_shared">
        This link cannot be made editable as it resides within a
        shared folder. Links within shared folders are restricted from editing to maintain
        collaborative integrity and data security.
    </div>
  </div>

  <sync-divider *ngIf="fileType === 'dir' && isPro"></sync-divider>

  <div *ngIf="fileType === 'dir' && isPro">
    <sync-section-header [header]="'Allow file uploads'" [description]="''" [level]="'subtitle'"
        [showActions]="true" [showSwitch]="true" formControlName="upload"
        [switchConfig]="{size: 'large', disabled: false, label: '', labelPosition: 'after', required: true, ariaDescribedby: '', ariaLabel: '', ariaLabelledby: '', name: ''}">
    </sync-section-header>
  </div>

  <sync-divider *ngIf="isPro"></sync-divider>

  <div >
    <sync-section-header [header]="'Password'" [description]="'Set password access to this link'"
        [level]="'subtitle'" [showActions]="true" [showSwitch]="true" formControlName="use_password"
        [switchConfig]="{size: 'large', disabled: linkEnforcedSettings.isLinkPasswordRequired, label: '', labelPosition: 'after', required: true, ariaDescribedby: '', ariaLabel: '', ariaLabelledby: '', name: ''}">
    </sync-section-header>
    
    <sync-text-field
        *ngIf="shouldShowPassword"
        [label]="'Link password'"
        inputType="password"
        formControlName="passwordprotect"
        [errorMessage]="getErrorMessage('passwordprotect')">
    </sync-text-field>
  </div>

  <sync-divider *ngIf="isPro"></sync-divider>

  <div *ngIf="isPro">
    <sync-section-header [header]="'Link expiration'" [description]="'Set an expiry date and time'"
        [level]="'subtitle'" [showActions]="true" [showSwitch]="true" formControlName="use_link_expiry"
        [switchConfig]="{size: 'large', disabled: !isPro || linkEnforcedSettings.isLinkExpiryDateRequired, label: '', labelPosition: 'after', required: true, ariaDescribedby: '', ariaLabel: '', ariaLabelledby: '', name: '', checked: linkEnforcedSettings.isLinkExpiryDateRequired}">
    </sync-section-header>
    
    <div class="link-expiration" *ngIf="shouldShouldLinkExpiry">
        <div class="expiry-date">
            <sync-datepicker
                [label]="'Expiry Date'"
                [type]="'datepicker'"
                [minDate]="expDateMin"
                formControlName="exp_date"
                [errorMessage]="getErrorMessage('exp_date')"
                [caption]="true"
                captionHint="MM/DD/YYYY"
                [onDateChange]="onExpDateChange"
            ></sync-datepicker>
        </div>
        <div class="expiry-time">
            <sync-timepicker
                [label]="'Expiry time'"
                formControlName="exp_time"
                [errorMessage]="getErrorMessage('exp_time')"
            ></sync-timepicker>
        </div>
    </div>
  </div>
</div>